import { SubmissionInternalQualificationId } from '@core/constants/SubmissionInternalSaleStatus';

const InternalQualificationStatusFR: { [key in SubmissionInternalQualificationId]: string } = {
    infosOk         : 'Infos OK',
    waitingDocument : 'En attente de document(s)',
    toRecontact     : 'A recontacter',
};

export default InternalQualificationStatusFR;
